enum AccountStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

export default AccountStatus;
